// extracted by mini-css-extract-plugin
export default {"label":"Search_label__PXU68","input":"Search_input__trH3b"};